// extracted by mini-css-extract-plugin
export default {"container":"Checkbox_container__CDkr7","checkmark":"Checkbox_checkmark__39R26"};